export const MY_CAL_FILTER_OPTION_KEYS = {
  EVENTS: 'events',
  ORGANIZATIONS: 'organizations',
  SPORTS: 'sports',
  NEAR_ME: 'near_me',
} as const;

export const SYNC_SYSTEM_OPTION_KEYS = {
  GOOGLE: 'google',
  YAHOO: 'yahoo',
  OUTLOOK: 'outlook',
  APPLE_CALENDAR: 'apple_calendar',
  ICAL: 'ical',
} as const;

export type myCalFilterOptionsKeys =
  typeof MY_CAL_FILTER_OPTION_KEYS[keyof typeof MY_CAL_FILTER_OPTION_KEYS];

export interface MyCalOption {
  key: myCalFilterOptionsKeys;
  title: string;
  is_selected?: boolean;
}

export interface SyncSystemOption {
  key: typeof SYNC_SYSTEM_OPTION_KEYS[keyof typeof SYNC_SYSTEM_OPTION_KEYS];
  title: string;
}
